<template>
  <div style="display: inline">
    <div class="btn btn-wd dropbox" v-bind:class="{'btn-disabled': disabled, 'btn-danger': inError, 'btn-fill': !inError}">
      <input type="file" name="file" @change="onChange($event)" :accept="accept" class="input-file" v-bind:disabled="disabled">
      <p><i :class="inputIconClass"></i>&nbsp;{{inputText}}</p>
    </div>
  </div>
</template>

<script>
  import ModalMessage from 'src/components/ModalPlugin/ModalMessage'
  export default {
    name: "base64-uploader",
    components: {
      ModalMessage
    },
    props: {
      inputText: { type: String, default: 'Upload' },
      inputIconClass: { type: String, default: 'fa fa-upload' },
      inError: { type: Boolean, default: false },
      disabled: { type: Boolean, default: false }
    },
    data () {
      return {
        //accept: 'application/pdf, image/jpeg, image/jpg, image/png',
        accept: 'application/pdf',
        maxSize: 5, // megabytes
        file: null
      }
    },
    methods: {
      onChange (e) {
        const files = e.target.files || e.dataTransfer.files;

        if (!files.length) {
          return;
        }

        const file = files[0];
        const size = file.size && (file.size / Math.pow(1000, 2));

        // check file max size
        if (size > this.maxSize) {
          this.sizeExceeded(size);
          return;
        }

        // update file
        this.file = file;
        this.$emit('file', file);

        const reader = new FileReader();

        reader.onload = e => {
          var dataURI = e.target.result;
          if (dataURI) {
            dataURI = dataURI.replace("data:application/pdf;base64,", "");
            //dataURI = dataURI.replace("data:image/jpeg;base64,", "");
            //dataURI = dataURI.replace("data:image/jpg;base64,", "");
            //dataURI = dataURI.replace("data:image/png;base64,", "");
            
            if(dataURI.startsWith("data:")) {
              this.$snotify.error("Could not read file, check supported file types.", "Error", {timeout: 7500})
              this.file = null
            } else {
              this.$emit('data', file.name, dataURI);
              this.uploaded = true
            }
          }
        };

        // read blob url from file data
        reader.readAsDataURL(file);
      },
      sizeExceeded(size) {
        this.$snotify.error("File " + size + "Mb size exceeds limits of " + this.maxSize + "Mb", "Error", {timeout: 7500})
        this.$snotify.error("Please use any of the free online tools to compress your file to less than " + this.maxSize + "Mb", "Error", {timeout: 7500})
      }
    }
  }
</script>

<style scoped>
  .input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 38px;
    position: absolute ;
    cursor: pointer;
  }
  .dropbox {
    padding: 0px 0px;
    min-height: 38px; /* minimum height */
    position: relative;
    cursor: pointer;
  }
  .dropbox p {
    padding: 5px 0px;
    margin: 0px 0px;
    font-weight: 400;
    font-size: 18;
  }
  .done {
    background-color: inherit;
    color: inherit;
    cursor: inherit;
  }
  .done:hover {
    background-color: inherit !important;
    color: inherit;
    cursor: inherit;
  }
  .doc-delete {
    cursor: pointer;    
  }
</style>